/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reconcile_Ignore_TitleInputs */

const vi_reconcile_ignore_title = /** @type {(inputs: Reconcile_Ignore_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bỏ qua khoản CK`)
};

/**

* @param {Reconcile_Ignore_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const reconcile_ignore_title = /** @type {((inputs?: Reconcile_Ignore_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reconcile_Ignore_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_reconcile_ignore_title(inputs)
});